import { getQueryString } from '@common/libs/util.url.js'

let isFirstIn = true

export default function (router) {
  // 全局导航钩子
  router.beforeEach((to, from, next) => {
    if (isFirstIn) {
      isFirstIn = false
      const inviteCode =
        getQueryString('invitecode') ||
        getQueryString('rid').split('-')[0] ||
        null
      if (inviteCode) {
        return next({ name: 'open', replace: true })
      }
      const page = getQueryString('page')
      if (page) {
        return next({ name: page, replace: true })
      }
    }
    return next()
  })
}
